export default __webpack_public_path__ + "static/welcome-back-desktop-3ccb47b1ae7711caa1e57608ef5bd1bc.webp";